import styled from "styled-components";

export const LoadingContainer = styled.div`
  margin: 0 10px;
  display: flex;
  justify-content: center;
`;

export const LiveGames = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 15px;
  border-radius: 5px;
  h2 {
    font-weight: 100;
  }
`;

export const LiveCards = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.bottomColor};
  padding: 5px;
  margin-top: 10px;
  border-radius: 5px;

  overflow: hidden;
`;

export const LiveTeams = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 10px 0px;
  img {
    max-width: 100%;
    width: 20px;
    object-fit: contain;
  }
  span {
    font-size: 0.8rem;
  }
`;

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => props.theme.fontColor}80;
  text-align: center;
  span {
    font-size: 60px;
    margin-bottom: 10px;
    transform: rotate(90deg);
  }
`;


export const GamesButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  background-color: ${(props) => props.theme.secondary}1a;
  padding: 4px 8px;
  border: unset;
  border-radius: 5px;
  color: ${(props) => props.theme.secondary};
  margin-top: 10px;
`;